import type { Season } from '../types/electricity'

// Rates in agorot per kWh (including VAT) — per season
// Source: IEC חח"י תעו"ז tariff
// Transition: updated Mar 1 2026, Winter/Summer: Jan 2026
export const RATES: Record<Season, { peak: number; offpeak: number }> = {
  winter:     { peak: 120.71, offpeak: 45.57 },
  transition: { peak: 50.66,  offpeak: 46.55 },
  summer:     { peak: 168.95, offpeak: 52.83 },
}

// Rate update date for display
export const RATE_UPDATE_DATE = 'מרץ 2026'

// Peak hours by season (start inclusive, end exclusive)
export const PEAK_HOURS: Record<Season, { start: number; end: number }> = {
  winter:     { start: 17, end: 22 },
  transition: { start: 17, end: 22 },
  summer:     { start: 17, end: 23 },
}

// Month ranges for seasons (1-indexed)
export const SEASON_MONTHS: Record<Season, number[]> = {
  winter:     [12, 1, 2],
  transition: [3, 4, 5, 10, 11],
  summer:     [6, 7, 8, 9],
}

export const SEASON_NAMES: Record<Season, string> = {
  winter: 'חורף',
  transition: 'מעבר',
  summer: 'קיץ',
}
